import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, TemplateRef, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { MsalService } from '@azure/msal-angular';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../../search-users/search-users.component';
import { AddMapCapaComponent } from '../../add-map-capa/add-map-capa.component';

@Component({
  selector: 'app-oos-actions',
  templateUrl: './oos-actions.component.html',
  styleUrls: ['./oos-actions.component.scss']
})

export class OosActionsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() activityData: boolean;
  @Output() valueChange = new EventEmitter<{ action: [] }>;
  event = { isUserInput: true, source: { _selected: true, } }
  dateCustomClasses: DatepickerDateCustomClasses[];
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  action: any = {};
  auditTrail: any = {};
  editData: any = {};

  tabs: any = [];
  buttonList: any = [];
  reviewStatus: any = [];
  label: any = [];
  dynamicLabel: any = null;
  selectedTabIndex: number = 0;
  phase: string = 'I';
  popupDataTitle: string = '';

  isProcessing: boolean = false;
  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  isAdEnabled: boolean = false;
  isPlanFrozen: boolean = false;
  isExecutionFrozen: boolean = false;
  getOnlyActionDetails: boolean = false;
  visibleEditButton: boolean = false;

  departmentList: any = [];
  designationList: any = [];
  requestedAtList: any = [];
  deferReviewerList: any = [];
  deferApproverList: any = [];
  reviewerList: any = [];
  approverList: any = [];
  analyserList: any = [];
  investigationTechniqueList: any = [];

  departmentDropdown: any = [];
  requestedAtDropdown: any = [];
  deferReviewerDropdown: any = [];
  deferApproverDropdown: any = [];
  reviewerDropdown: any = [];
  approverDropdown: any = [];
  analyserDropDown: any = [];
  investigationTechniqueDropDown: any = [];
  moduleNameForDropdown: any = [];

  isResponsibleDepartmentOdd: any = null;
  isAssignToDepartmentOdd: any = null;
  isReviewerOdd: any = null;
  isApproverOdd: any = null;
  oddDeferReviewer: any = null;
  oddDeferApprover: any = null;

  departmentSearchText: string = '';
  analyserSearchText: string = '';
  investigationTechniqueSearchText: string = '';
  planReviewerSearchText: string = '';
  planApproverSearchText: string = '';
  requestedAtTxt: string = '';
  coreBusinessAreaNameTxt: string = '';
  assignedUserTxt: string = '';
  departmentCodeTxt: string = '';
  reviewUserTxt: string = '';
  reviewUserTxt1: string = '';
  approveUserUserTxt: string = '';
  approveUserUserTxt1: string = '';
  deferReviewUserTxt: string = '';
  deferReviewUserTxt1: string = '';
  deferApproveUserTxt: string = '';
  deferApproveUserTxt1: string = '';
  designationCodeTxt: string = '';

  constructor(
    readonly qualityService: qmsService,
    readonly message: messageService,
    readonly appService: AppService,

    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly renderer: Renderer2,
    private readonly paginationService: PaginationService,
    private readonly dialog: MatDialog,
    private readonly authService: MsalService,
    private readonly elem: ElementRef
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    this.tabs = [
      { tab_icon: "/assets/img/one.png", tab_name: "Phase I Action" },
      { tab_icon: "/assets/img/two.png", tab_name: "Phase II Action" },
      ...(this.qualityService.activity.phaseIIIInvestigationReqd ? [{
        tab_icon: "/assets/img/three.png", tab_name: "Phase III Action"
      }] : [])
    ];

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

    if (this.qualityService.selectedGroup != null) {
      this.requestedAtList = [];
      this.isProcessing = true;
      this.departmentList = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
      this.designationList = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
      this.moduleNameForDropdown = localStorage.getItem("moduleNameFromCr");

      this.selectBoxForDepartment();

      this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Reviewer').subscribe((data: any) => {
        this.reviewerList = data;
        this.selectBoxForReviewer();
      })

      this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Approver').subscribe((data: any) => {
        this.approverList = data;
        this.selectBoxForApprover();
      })

      this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Deferred Reviewer').subscribe((data: any) => {
        this.deferReviewerList = data;
        this.selectBoxForDeferReviewer();
      })

      this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Deferred Approver').subscribe((data: any) => {
        this.deferApproverList = data;
        this.selectBoxForDeferApprover();
      })

      this.appService.getQmsBusinessAreasByModule(this.qualityService.moduleName).subscribe((data: any) => {
        this.requestedAtList = data;
        this.selectBoxForRequestedAt();
      })

      this.appService.getQmsActiveGroupUsers(this.qualityService.activity.groupId, "OOS", 'Analyser').subscribe((analyser: any) => {
        this.analyserList = analyser;
        this.selectBoxForAnalyser();
      })

      this.appService.getCodeListsByGroup("INVESTIGATION_TECHNIQUE").subscribe((technique: any) => {
        this.investigationTechniqueList = technique;
        this.selectBoxForInvestigationTechnique();
      })

      if (this.message.showSwitchUser) {
        this.message.showSwitchUser = true;
      } else {
        this.message.showSwitchUser = false;
      }

      if (this.qualityService.activityId) {
        if (this.activityData) {
          this.getCall();
        } else {
          this.openEditPopup(this.message.taskLevelData, 0);
        }
      }
    }
  }

  snackbarRef: any;
  ngAfterViewInit(): void {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  private selectBoxForDepartment(): void {
    this.departmentDropdown = this.departmentList?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  public onResponsibleDepartmentSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('responsible-dept', item);
    }
  }

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.map((requestedAt: any) => ({
      valueExp: requestedAt.taskRequestedAt,
      displayExp: requestedAt.taskRequestedAt,
      listOfBusinessArea: requestedAt.listOfBusinessArea
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  private selectBoxForDeferReviewer(): void {
    this.deferReviewerDropdown = this.deferReviewerList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onDeferReviewerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('defer-reviewer', item);
    }
  }

  private selectBoxForDeferApprover(): void {
    this.deferApproverDropdown = this.deferApproverList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onDeferApproverSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('defer-approver', item);
    }
  }

  private selectBoxForReviewer(): void {
    this.reviewerDropdown = this.reviewerList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onReviewerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('reviewer', item);
    }
  }

  private selectBoxForApprover(): void {
    this.approverDropdown = this.approverList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onApproverSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('approver', item);
    }
  }

  private selectBoxForAnalyser(): void {
    this.analyserDropDown = this.analyserList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  private selectBoxForInvestigationTechnique(): void {
    this.investigationTechniqueDropDown = this.investigationTechniqueList?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  public validateNumberFields(event: KeyboardEvent): void {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  public onTabChanged(event: any): void {
    if (this.selectedTabIndex == 0) {
      this.phase = 'I';
    } else if (this.selectedTabIndex == 1) {
      this.phase = 'II';
    } else {
      this.phase = 'III';
    }
    this.getCall();
  }

  public aesthetic(): boolean {
    return (this.selectedTabIndex == 0 && !this.qualityService.activity.phaseIIInvestigationReqd) || (this.selectedTabIndex == 1 && !this.qualityService.activity.phaseIIIInvestigationReqd) || this.selectedTabIndex == 2;
  }

  public focusSearch(value: any): void {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'initial-complaint-category-validation' || fieldId === 'final-complaint-category-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  public mandatoryValidation(elementIds: any): void {
    elementIds.forEach((elementId: any) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    })
  }

  private getDynamicLabel(): void {
    this.isProcessing = true;
    let data = {
      tableName: 'QMS_OOS_ACTIONS_VW',
      moduleName: this.qualityService.moduleName,
      gridName: 'OOS_ACTIONS',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private getDynamicButtons(): void {

    const obj = { actionId: this.action.actionId };

    this.appService.getOosActionButtons(obj).subscribe((button: any) => {
      if (button.labelsResult) {
        button.labelsResult = button.labelsResult + ",Cancel";
        this.buttonList = button.labelsResult.split(",");
      } else {
        button.labelsResult = "Cancel";
        this.buttonList = button.labelsResult.split(",");
      }
    })
  }

  public openAddPopup(): void {
    this.isAssignToDepartmentOdd = null;
    this.isReviewerOdd = null;
    this.buttonList = ["Save", "Cancel"];
    this.action = {};
    this.visibleEditButton = false;
    this.popupDataTitle = "Create Action";
    this.qualityService.getQmsActionDataUsingById = {};
    this.action.actionDescription = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  };

  public cancelAddAndEditFunction(): void {
    this.qualityService.getQmsActionDataUsingById.status = undefined;
    this.visibleAddAndEditPopup.close();
  }

  public openEditPopup(data: any, id: any): void {
    this.deleteData = this.editData = data;
    this.message.subModuleId = data.ACTION_ID;
    this.objForDocuments = { id: data.ACTION_ID, pagename: "Action" };
    if (id == 0 || id == 1) {
      this.buttonList = [];
      this.isProcessing = true;
      this.action = {};
      this.appService.getOosActionsByActionId(data.ACTION_ID).subscribe((data: any) => {

        data.actionPerformed = data.actionPerformed == "Y";
        data.targetDate = new Date(data.targetDate);
        data.dueReminderSentOn = data.dueReminderSentOn ? new Date(data.dueReminderSentOn) : null;
        data.actionCompletedOn = data.actionCompletedOn ? new Date(data.actionCompletedOn) : null;
        data.isCapaReqd = data.capaDetails;
        this.isPlanFrozen = data.status != 'Open' && +data.assignTo == +this.message.getUserId();
        this.isExecutionFrozen = data.status != 'Open' && +data.assignTo == +this.message.getUserId();
        this.popupDataTitle = "Update Action";
        this.action = this.qualityService.getQmsActionDataUsingById = data;
        this.setDataDropdown(data);
        this.setUserDropdown(data);
        this.getDynamicButtons();
        this.visibleEditButton = true;
        !this.getOnlyActionDetails && (this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig));
        this.getOnlyActionDetails && (this.getOnlyActionDetails = false);
        this.isProcessing = false;
      });
    }
  };

  private setDataDropdown(data: any): void {
    if (data.assignedToDepartment) {
      const matchingDepartment = this.departmentDropdown?.find((x: any) => x.valueExp === data.assignedToDepartment);
      if (matchingDepartment) {
        this.isAssignToDepartmentOdd = null;
      } else {
        this.isAssignToDepartmentOdd = data.assignedToDepartment;
        this.departmentDropdown.push({ valueExp: data.assignedToDepartment, displayExp: data.assignedToDepartment });
      }
    }

    if (data.responsibleDepartment) {
      const matchingResponsibleDepartment = this.departmentDropdown.find((x: any) => x.valueExp === data.responsibleDepartment);
      if (matchingResponsibleDepartment) {
        this.isResponsibleDepartmentOdd = null;
      } else {
        this.isResponsibleDepartmentOdd = data.responsibleDepartment;
        this.departmentDropdown.push({ valueExp: data.responsibleDepartment, displayExp: data.responsibleDepartment });
      }
    }
  }

  private setUserDropdown(data: any): void {
    if (data.reviewedByUser) {
      const matchingReviewer = this.reviewerDropdown.find((x: any) => x.valueExp === data.reviewedByUser);

      if (matchingReviewer) {
        this.isReviewerOdd = null;
      } else {
        this.isReviewerOdd = data.reviewedByUser;
        this.reviewerDropdown.push({ valueExp: data.reviewedByUser, displayExp: data.reviewer });
      }
    }

    if (data.approvedByUser) {
      const matchingApprover = this.approverDropdown.find((x: any) => x.valueExp === data.approvedByUser);

      if (matchingApprover) {
        this.isApproverOdd = null;
      } else {
        this.isApproverOdd = data.approvedByUser;
        this.approverDropdown.push({ valueExp: data.reviewedByUser, displayExp: data.reviewer });
      }
    }

    if (data.deferReviewedByUser) {
      const matchingDeferReviewer = this.deferReviewerList.find((deferReviewer: any) => deferReviewer.userId == data.deferReviewedByUser)
      if (!matchingDeferReviewer) {
        this.oddDeferReviewer = data.deferReviewedByUser;
        this.deferReviewerDropdown.push({ valueExp: data.deferReviewedByUser, displayExp: data.deferReviewer })
      }
    }

    if (data.deferApprovedByUser) {
      const matchingDeferApprover = this.deferApproverList.find((deferApprover: any) => deferApprover.userId == data.deferApprovedByUser)
      if (!matchingDeferApprover) {
        this.oddDeferApprover = data.deferApprovedByUser;
        this.deferApproverDropdown.push({ valueExp: data.deferApprovedByUser, displayExp: data.deferApprover })
      }
    }
  }

  public addAndEditFunction(action: any): Promise<boolean> {
    return new Promise(async (resolve) => {
      const validations: any = [];

      const status = this.qualityService.activity.status;
      if (this.isInProgressStatus(status) && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
        setTimeout(() => {
          this.showSnackBar("This activity is locked. Please refresh or contact admin.", "E");
        }, 0);

        this.isProcessing = false;
        resolve(false); return;
      }

      if (this.searchUsersComponent.isSwitchingUser) {
        validations.push([]);
      } else {
        validations.push(
          { condition: !action.actionName, id: 'actionName-validation' },
          { condition: !action.targetDate, id: 'targetDate-validation' },
          { condition: !action.assignedTo, id: 'assignedTo-validation' },
          ...this.buildInProgressValidations(action)
        );
      }

      const invalidIds = validations.filter((validation: any) => validation.condition).map((validation: any) => validation.id);

      if (invalidIds.length > 0) {
        this.mandatoryValidation(invalidIds);
        this.showSnackBar('Please enter all mandatory fields', 'E');
        this.isProcessing = false;
        resolve(false);
      } else {
        this.prepareObj(action, resolve);
      }
    });
  }

  private isInProgressStatus(status: string): boolean {
    return ["In Progress", "PhaseII In Progress", "PhaseIII In Progress"].includes(status);
  }

  private buildInProgressValidations(action: any): any[] {
    if (!(this.visibleEditButton && action.status == 'In Progress')) return [];
    return [
      { condition: !!action.actionPerformed && !action.performedActionDetails, id: 'field-name' },
      { condition: !action.investigationResults, id: 'results' },
      { condition: !action.rootCause, id: 'root-cause' },
      { condition: !action.conclusion, id: 'conclusion' }
    ];
  }

  private prepareObj(action: any, resolve: (value: boolean) => void) {
    const obj = {
      oosNo: this.qualityService.activityId,
      ...action,
      targetDate: action.targetDate ? this.appService.dateZoneConvertion(new Date(action.targetDate)) : null,
      actionPerformed: action.actionPerformed ? "Y" : "N",
      actionCompletedOn: action.actionCompletedOn ? this.appService.dateZoneConvertion(new Date(action.actionCompletedOn)) : null,
      overdueNotificationSentOn: action.overdueNotificationSentOn ? this.appService.dateZoneConvertion(new Date(action.overdueNotificationSentOn)) : null,
      dueReminderSentOn: action.dueReminderSentOn ? this.appService.dateZoneConvertion(new Date(action.dueReminderSentOn)) : null,
      phase: this.phase,
    };

    if (this.visibleEditButton) {
      this.update(obj, resolve);
    } else {
      this.create(obj, resolve);
    }
  }

  private create(action: any, resolve: (value: boolean) => void) {
    this.isProcessing = true;
    this.appService.createOosActions(action).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.getDynamicButtons();
          if (this.searchUsersComponent.isSwitchingUser) {
            this.switchuserComponent.cancelSwitchUserPopup();
            this.switchuserComponent.closeConfirmationPopup();
            this.searchUsersComponent.isSwitchingUser = false;
          }
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
          resolve(true);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
          resolve(false);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        this.showSnackBar("Error occurred", 'E');
        console.error('error →', error);
        resolve(false);
      }
    });
  }

  private update(action: any, resolve: (value: boolean) => void) {
    this.isProcessing = true;
    const modifiedAction = {
      ...action,
      actionId: action.actionId,
      slNo: action.slNo
    };

    this.appService.updateOosActions(modifiedAction).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          if (!this.dynamicUpdate) {
            this.getCall();
            this.getDynamicButtons();
            this.getOnlyActionDetails = true;
            this.action.ACTION_ID = this.action.actionId;
            this.openEditPopup(this.action, 0);
          }
          if (this.searchUsersComponent.isSwitchingUser) {
            this.switchuserComponent.cancelSwitchUserPopup();
            this.switchuserComponent.closeConfirmationPopup();
            this.searchUsersComponent.isSwitchingUser = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
          resolve(true);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
          resolve(false);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        this.showSnackBar("Error occurred", 'E');
        console.error('error →', error);
        resolve(false);
      }
    });
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmValidationPopup', { static: true }) confirmValidationPopup: TemplateRef<any>;
  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('clobPopup', { static: true }) clobPopup: TemplateRef<any>;
  visibleClobPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '91vw',
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  config: EditorConfig = {
    buttons: [],
  };

  confirmValidationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  clobPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  private lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService?.activity?.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  visibleActionPerform: boolean;
  deleteData: any;
  objForDocuments: any;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  selectedStatus: any = null;

  public async dynamicButtonClick(button: any): Promise<void> {
    const status = this.qualityService.activity.status;
    if ((status == "In Progress" || status == "PhaseII In Progress" || status == "PhaseIII In Progress") && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false }
    this.buttonLabel = button;
    this.selectedStatus = null;
    this.reason = "";
    this.password = "";
    this.userName = localStorage.getItem("loggedUserName");
    this.isEsignRequired = false;
    this.isReasonSignReqd = true;
    this.isEsignRequired = true;
    this.hidePassword = true;
    let array: [] = [];
    if (button == "Delete") {
      this.openDeletePopup(this.deleteData);
    } else {
      if (button == "Review" || button == "Plan Review") {
        this.reviewStatus = ['Reviewed', 'Review Rejected'];
      } else if (button == "Approve" || button == "Plan Approve") {
        this.reviewStatus = ['Approved', 'Approval Rejected'];
      }
      this.isProcessing = true;
      this.appService.getDocumentsForActions(this.qualityService.activityId, this.message.subModuleId).subscribe((response: any) => {
        array = response;
        this.isProcessing = false;
        if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && !this.action.actionPerformed) {
          this.showSnackBar("The action to be performed before Submit for Review", "E");
        } else if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && (this.action.actionPerformed && !this.action.performedActionDetails)) {
          this.showSnackBar("Please enter Performed Action Details", "E");
        } else if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && this.action.actionPerformed && !array.length) {
          this.showSnackBar("Please add supporting documents for Actions", "E");
        } else {
          this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
        }
      })
    }
  }

  private dynamicButtonFieldValidation() {
    console.log('Something');
  }

  private async getButtonOperation() {
    if (this.buttonLabel === "Review" || this.buttonLabel === "Approve") {
      return this.selectedStatus;
    } else if (this.buttonLabel === "Plan Review" || this.buttonLabel === "Plan Approve") {
      if (this.selectedStatus == 'Reviewed' || this.selectedStatus == 'Approved') {
        return this.selectedStatus;
      } else {
        return this.buttonLabel === "Plan Review" ? 'Plan Review Rejected' : 'Plan Approval Rejected';
      }
    } else {
      return this.buttonLabel;
    }
  }

  dynamicUpdate: boolean = false;
  private async triggerActionPackage() {
    this.dynamicUpdate = true;
    const isValid = await this.addAndEditFunction(this.action);

    if (!isValid) return;

    const data = {
      actionId: this.action.actionId,
      currentStatus: this.action.status,
      buttonOperation: await this.getButtonOperation(),
      comments: this.reason,
    };

    this.appService.performOosActionsAction(data).subscribe((Response: any) => {
      if (Response.resultType == "S") {
        this.getDynamicButtons();
        this.getOnlyActionDetails = true;
        this.action.ACTION_ID = this.message.subModuleId;
        this.openEditPopup(this.action, 0);
        this.getCall();
        this.dynamicUpdate = false;
        this.visibleConfirmWithReason.close();
      } else {
        this.isProcessing = false;
      }
      this.showSnackBar(Response.result, Response.resultType);
    });
  }

  confirmWithReason() {
    if ((localStorage.getItem("adEnabled") != 'Y' && this.password == '') || ((this.buttonLabel == 'Review' || this.buttonLabel == 'Plan Review' || this.buttonLabel == 'Plan Approve' || this.buttonLabel == 'Approve') && (this.selectedStatus.includes("Rejected") && (this.reason == "" || this.reason == null)))) {
      this.dynamicButtonFieldValidation();
      this.showSnackBar('Please enter all mandatory Fields!', 'E');
    } else if (this.buttonLabel == "Defer Action") {
      if ((localStorage.getItem("adEnabled") != 'Y' && this.password == '') || this.action.deferReviewedByUser == null || this.action.deferApprovedByUser == null) {
        this.dynamicButtonFieldValidation();
        this.showSnackBar('Please enter all mandatory Fields!', 'E');
      } else {
        this.execute();
      }
    } else if (this.buttonLabel == "Submit for Review" && this.action.reviewedByUser == null) {
      this.isProcessing = false;
      this.showSnackBar("Please select reviewer before submit for review", "E");

    } else if (this.buttonLabel == "Submit for Review" && this.action.approvedByUser == null) {
      this.isProcessing = false;
      this.showSnackBar("Please select approver before submit for review", "E");

    } else if (this.buttonLabel == "Review" || this.buttonLabel == "Plan Review" || this.buttonLabel == "Approve" || this.buttonLabel == "Plan Approve" || this.buttonLabel == "Submit for Review" || this.buttonLabel == "Submit for Plan Review" || this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Submit for Plan Approval") {
      this.execute();
    } else {
      this.triggerActionPackage();
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  closeConfirmValidationPopup() {
    this.visibleValidationConfirm.close();
  };

  execute() {
    if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable();
    } else {
      let data = { userName: this.userName, password: this.password }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          this.triggerActionPackage();
        } else {
          this.showSnackBar(data.result, data.resultType);
          this.isProcessing = false;
        }
      })
    }
  }

  authEnable() {
    this.authService.loginPopup({ scopes: ["User.Read"], prompt: "login" }).subscribe({
      next: (result) => {
        let oldLoginUser = localStorage.getItem("loggedUserName")?.toUpperCase();
        let newUser = result.account?.username.toUpperCase();
        if (oldLoginUser === newUser) {
          this.triggerActionPackage();
        }
      },
      error: (error) => {
        this.isProcessing = false;
      }
    });
  }

  openDeletePopup(data: any) {
    this.getOnlyActionDetails = true;
    this.action.ACTION_ID = this.action.actionId;
    this.openEditPopup(this.action, 0);
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  };

  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
    maxDate: new Date(this.qualityService?.activity?.expcetedClosureOn),
    adaptivePosition: true
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction() {
    delete this.action.createdOn;
    delete this.action.updatedOn;
    this.action.oosNo = this.qualityService.activityId;
    this.action.module = this.qualityService.moduleName;
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      this.action.actionPerformed = this.action.actionPerformed ? "Y" : "N";
      this.appService.deleteOosActions(this.action).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleAddAndEditPopup.close();
            this.visibleDeletePopup.close();
            this.getCall();
          }
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  async openswitchuser(value: any) {
    const status = this.qualityService.activity.status;
    if ((status == "In Progress" || status == "PhaseII In Progress" || status == "PhaseIII In Progress") && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else {
      this.isProcessing = false;
    }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = "Action";
    this.message.switchuserRole = value;
    if (value == "reviewer") {
      this.message.switchUserCurrentValue = this.action.reviewedByUser;
      this.message.switchedUser = this.action.reviewedByUser;
      this.message.switchUserdropDownList = this.reviewerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "approver") {
      this.message.switchUserCurrentValue = this.action.approvedByUser;
      this.message.switchedUser = this.action.approvedByUser;
      this.message.switchUserdropDownList = this.approverDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "deferReviewer") {
      this.message.switchUserCurrentValue = this.action.deferReviewedByUser;
      this.message.switchedUser = this.action.deferReviewedByUser;
      this.message.switchUserdropDownList = this.deferReviewerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "deferApprover") {
      this.message.switchUserCurrentValue = this.action.deferApprovedByUser;
      this.message.switchedUser = this.action.deferApprovedByUser;
      this.message.switchUserdropDownList = this.deferApproverDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "planreviewer") {
      this.message.switchUserCurrentValue = this.action.actionPlanReviewer;
      this.message.switchedUser = this.action.actionPlanReviewer;
      this.message.switchUserdropDownList = this.reviewerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "planapprover") {
      this.message.switchUserCurrentValue = this.action.actionPlanApprover;
      this.message.switchedUser = this.action.actionPlanApprover;
      this.message.switchUserdropDownList = this.approverDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchuserComponent.openswitchuser(value, this.qualityService.moduleName);
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "reviewer") {
      this.action.reviewedByUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "approver") {
      this.action.approvedByUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "deferReviewer") {
      this.action.deferReviewedByUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "deferApprover") {
      this.action.deferApprovedByUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "planreviewer") {
      this.action.actionPlanReviewer = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "planapprover") {
      this.action.actionPlanApprover = this.message.switchedUser;
    }
    this.addAndEditFunction(this.action);
  }

  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'AU': this.qualityService.activity.auId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, action: any) {
    this.auditTrail.oosNo = viewType == 'overAll' ? null : action.ACTION_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityoosNo = this.message.activityId;
    this.auditTrail.gridName = 'OOS_ACTIONS';
    this.auditTrail.report_And_Popup_Name = this.qualityService.moduleName + ' Action Audit Trail [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(action);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.gridObj = { ...this.gridObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qualityService.moduleName + ' Action Report [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.gridObj.gridName, this.gridObj.tableOrViewName, this.qualityService.moduleName, 0)
  }

  onChildValueEmit() {
    this.getCall();
    this.getDynamicLabel();
  };

  hidePassword: boolean = true;
  showPassword() {
    this.hidePassword = !this.hidePassword;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Action Description': this.dynamicLabel?.['ACTION_DESCRIPTION']?.fieldName,
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchAssignTo(workingFor: string) {
    this.searchUsersComponent.popupTitle = 'Assign To';
    this.searchUsersComponent.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.action.assignedToUser);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.action.assignedToUser = this.qualityService.selectedSearchUserId;
    this.action.assignedTo = this.qualityService.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addAndEditFunction(this.action);
    }
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  closeHtmlContent() {
    this.visibleClobPopup.close();
  }

  grid: any = [];
  gridTemp: any = [];
  selectedGridData: any = [];
  gridObj: any = {};

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  parentCheckBox: boolean = false;

  getCall() {
    this.isProcessing = true;
    this.selectedGridData = [];
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "OOS_ACTIONS",
      groupId: 0
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          oosNo: this.qualityService.activityId,
          oosActionPhase: this.phase
        }
        this.gridObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.getDynamicLabel()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      this.selectedGridData = [];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.TEMPLATE_ID === checked.TEMPLATE_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.TEMPLATE_ID !== unchecked.TEMPLATE_ID);
  }

  refreshGrid() {
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  @ViewChild(AddMapCapaComponent) addMapCapaComponent!: AddMapCapaComponent;
  mapCapa() {
    this.addMapCapaComponent.openPopup();
  }

  onCapaEmitted() {
    this.action.capaDetails = this.message.addMapCapaComponentDetails.capaID + ' ' + this.message.addMapCapaComponentDetails.shortDescription;
  }

  unmapCapa() {
    this.action.capaDetails = null;
  }

  public focusEmpty(): void {
    console.log();
  }

}
